import { DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import {
  SaveButton,
  TextInput,
  SimpleForm,
  useDataProvider,
  useNotify,
  NumberInput,
  BooleanInput,
  useRefresh,
  useTranslate,
} from 'react-admin';

export default function CreateTask({ onClose }: { onClose: () => void }) {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const translate = useTranslate();
  const [saving, setSaving] = useState(false);
  const refresh = useRefresh();
  const onSubmit = async (values: any) => {
    setSaving(true);
    try {
      // 处理嵌套对象，确保数据格式正确
      const processedValues = {
        ...values,
        // 如果 name 是对象，确保格式正确
        name: typeof values.name === 'object' ? values.name : { en: values.name || '' },
        // 确保 points 是数字
        points: Number(values.points) || 0,
        // 确保 isActive 是布尔值
        isActive: Boolean(values.isActive),
      };

      await dataProvider.create('activity-tier-benefit', { data: processedValues });
      notify(translate('activity.tierBenefits.createdSuccessfully'), { type: 'success' });
      refresh();
      onClose();
    } catch (error) {
      console.error('Create error:', error);
      notify(translate('activity.tierBenefits.failedToCreate'), { type: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <DialogTitle>{translate('activity.common.createTask')}</DialogTitle>
      <DialogContent>
        <SimpleForm onSubmit={onSubmit} toolbar={<SaveButton alwaysEnable disabled={saving} />}>
          <Stack spacing={2} sx={{ mt: 2 }}>
            <Typography variant="h6">{translate('activity.common.basicInformation')}</Typography>
            <TextInput source="tierName" label={translate('activity.common.name')} fullWidth required />
            <NumberInput source="tierLevel" label="Level" fullWidth required defaultValue={0} />
            <NumberInput source="minPoints" label="MinPoints" fullWidth required defaultValue={0} />
            <TextInput source="cashbackPercentage" label="CashbackPercentage" fullWidth required />
            <TextInput source="netFee" label="NetFee" fullWidth required />
            <TextInput source="benefitsDescription" label={translate('activity.common.description')} fullWidth multiline rows={3} />
            <TextInput source="tierColor" label="Color" fullWidth  />
            <TextInput source="tierIcon" label={translate('activity.common.icon')} fullWidth  />
          </Stack>
        </SimpleForm>
      </DialogContent>
    </>
  );
}
